import React from "react";
import useAuthenticationStore from "./Store";
import { AuthenticationViews } from "./types";
import RecoveryCodes from "./RecoveryCodes";
import { useNavigate } from "react-router-dom";

const RecoveryCodesContainer: React.FC = () => {
    const navigate = useNavigate();
    const { state, finishJoin } = useAuthenticationStore();
    const { serverError, isLoading } = state;

    return (
        <RecoveryCodes
            serverError={serverError}
            isLoading={isLoading}
            recoveryCodes={state.recoveryCodes ?? []}
            next={
                state.signInId
                    ? finishJoin
                    : () => {
                          navigate("../" + AuthenticationViews.mfa);
                      }
            }
        />
    );
};

export default RecoveryCodesContainer;
